import {
  STOCK_TAKING_CAR_MANAGEMENT_UPDATE_EXISTING_FAST_STOCK_LOADING_DATA_BEGIN,
} from '../constants';

export function updateExistingFastStockLoadingData(id,saveData) {
  return (dispatch) => {
    dispatch({
      type: STOCK_TAKING_CAR_MANAGEMENT_UPDATE_EXISTING_FAST_STOCK_LOADING_DATA_BEGIN,
      data: {id,saveData}
    })
  }
}